/**
 * CfssSupervisionPage — QP Supervision Visit Tracking
 *
 * MN 256B.0659 Subd 8: Qualified Professional supervision requirements
 * - Initial visit within 14 calendar days
 * - Year 1: Every 90 days
 * - Year 2+: Every 120 days
 *
 * Thin wrapper around shared SupervisionTrackingPage with CFSS config.
 *
 * Route: /cfss/supervision
 */

import { SupervisionTrackingPage } from '@/pages/shared-services';

export function CfssSupervisionPage() {
  return (
    <SupervisionTrackingPage
      title="QP Supervision Visits"
      subtitle="MN 256B.0659 Subd 8 — Track and document supervision visits"
      taskGroupRef="4-30-15"
      subjectLabel="Worker/Participant"
      scope="qp:supervision:conduct"
    />
  );
}

export default CfssSupervisionPage;
